import { render, staticRenderFns } from "./policyHolderForm.vue?vue&type=template&id=f015d5f4&scoped=true&"
import script from "./policyHolderForm.vue?vue&type=script&lang=js&"
export * from "./policyHolderForm.vue?vue&type=script&lang=js&"
import style0 from "./policyHolderForm.vue?vue&type=style&index=0&id=f015d5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f015d5f4",
  null
  
)

export default component.exports